const reservasRoutes = [
  {
    path: '/reservas',
    name: 'reservas',
    component: () => import('@/views/reserva/dashboard/Dashboard.vue'),
    meta: {
      resource: 'Auth',
      action: 'read',
      pageTitle: 'Reservas',
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Reservas', url: '/reservas' },
        { title: 'Todas', active: true },
      ],
    },
  },
  {
    path: '/reservas/view/:id',
    name: 'reservas-view',
    component: () => import('@/views/reserva/components/ReservaView.vue'),
    meta: {
      resource: 'Auth',
      action: 'read',
      parent: 'reservas',
      pageTitle: 'Reserva',
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Reservas', url: '/reservas' },
        { title: 'Detalhe', active: true },
      ],
    },
  },
  {
    path: '/reservas/new',
    name: 'reservas-new',
    component: () => import('@/views/reserva/components/ReservaNew.vue'),
    meta: {
      resource: 'Auth',
      action: 'read',
      parent: 'reservas',
      pageTitle: 'Reserva',
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Reservas', url: '/reservas' },
        { title: 'Nova', active: true },
      ],
    },
  },
  {
    path: '/reservas/confirmation',
    name: 'reservas-confirmation',
    component: () => import('@/views/reserva/components/ReservaConfirmation.vue'),
    meta: {
      resource: 'Auth',
      action: 'read',
      parent: 'reservas-new',
      pageTitle: 'Confirmação',
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Reservas', url: '/reservas' },
        { title: 'Termo', active: true },
      ],
    },
  },
]

export default reservasRoutes
